<!-- Confirm.vue -->
<template>
  <div class="wonder-confirm-container">
    <transition name="el-fade-in-linear">
      <div
        v-if="show"
        class="confirm-mask"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="show"
        class="confirm-wrapper"
      >
        <div
          class="confirm-container"
          :style="{ backgroundColor: bgColor }"
        >
          <div class="confirm-header">
            <h3>{{ title }}</h3>
          </div>
          <div class="confirm-body">
            <p>{{ content }}</p>
            <p
              v-if="warningText"
              class="warning-text"
            >
              {{ warningText }}
            </p>
          </div>
          <div class="confirm-footer">
            <button
              v-if="showCancelButton"
              class="btn-cancel"
              :style="{
                backgroundColor: cancelBgColor,
                color: cancelTextColor,
              }"
              @click="handleCancel"
            >
              {{ cancelButtonText }}
            </button>
            <button
              v-if="showConfirmButton"
              class="btn-confirm"
              :style="{
                backgroundColor: confirmBgColor,
                color: confirmTextColor,
              }"
              @click="handleConfirm"
            >
              {{ confirmButtonText }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
let timer = null;
export default {
  data() {
    return {
      show: false,
      // 默认配置
      title: '提示',
      content: '',
      bgColor: '',
      confirmButtonText: '确认',
      confirmBgColor: '',
      confirmTextColor: '',
      cancelButtonText: '取消',
      cancelBgColor: '',
      cancelTextColor: '',
      showCancelButton: true,
      showConfirmButton: true,
      warningText: '',
    };
  },
  methods: {
    handleConfirm() {
      this.show = false;
      this.resolve(true);
      this.cleanup();
    },
    handleCancel() {
      this.show = false;
      this.resolve(false);
      this.cleanup();
    },
    cleanup() {
      timer = setTimeout(() => {
        this.$destroy();
        this.$el.parentNode.removeChild(this.$el);
        clearTimeout(timer);
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/variable.scss';

.confirm-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 299;
}

.confirm-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 301;
  transform-origin: center;
  .confirm-container {
    width: 446px;
    padding-top: 32px;
    padding-bottom: 26px;
    padding-left: 32px;
    padding-right: 32px;
    background-color: $form-bg-color;
    box-sizing: border-box;
    border-radius: 12px;
    .confirm-header {
      font-size: 18px;
      margin-bottom: 20px;
      color: $confirm-title-color;
    }
    .confirm-body {
      margin-bottom: 25px;
      color: $confirm-sub-title-color;
      .warning-text {
        margin-top: 6px;
        color: #ff453e;
        font-size: 14px;
      }
    }
    .confirm-footer {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      button {
        padding: 0 28px;
        height: 36px;
        cursor: pointer;
        border-radius: 6px;
        &.btn-cancel {
          border: 1px solid $modal-label-border-color;
          color: $modal-label-text-color;
          background-color: transparent;
        }
        &.btn-confirm {
          background: linear-gradient(to right, $modal-confirm-start-color 0%, $modal-confirm-end-color 100%);
          color: #fff;
        }
      }
    }
  }
}
</style>
